import { openBlock as t, createElementBlock as o, createElementVNode as r } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
};
function l(a, e) {
  return t(), o("svg", n, [...e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      d: "M8 3.126a3.95 3.95 0 0 1 5.523 0 3.803 3.803 0 0 1 0 5.437L8.001 14 2.477 8.563a3.803 3.803 0 0 1 0-5.437 3.95 3.95 0 0 1 5.378-.136z"
    }, null, -1)
  ])]);
}
const i = { render: l };
export {
  i as default,
  l as render
};
